module.exports = __webpack_public_path__ + "static/img/helh413.86990dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/healthycockpit/helh413.png
// module id = Qvdw
// module chunks = 5